<ng-select
  [id]="elementId"
  [readonly]="disabled"
  [loading]="loading"
  (keyup)="updateValues($event.target.value)"
  (open)="markAsTouched()"
  (change)="onSelectValue($event)"
  [(ngModel)]="selectedValue"
  [placeholder]="placeholder"
  [clearable]="clearable"
  >
  @for (value of values | slice : slice[0] : slice[1]; track value) {
    <ng-option [value]="bindValue ? value[bindValue] : value">
      @if (bindLabel) {
        @if (!translate) {
          <span>{{ value[bindLabel] }}</span>
        }
        @if (translate) {
          <span>{{ 'GENERAL.'+value[bindLabel] | translate }}</span>
        }
      }
      @if (!bindLabel && optionText.objectKeys) {
        @for (optionsTextObjectKey of optionText.objectKeys; track optionsTextObjectKey; let i = $index) {
          <span
          [ngClass]="{
            'text-uppercase': optionsTextObjectKey.textMode == 1,
            'text-capitalize': optionsTextObjectKey.textMode == 2,
            'fw-bold': optionsTextObjectKey.bold
          }"
            >@if (i > 0) {
            <span>{{ optionText.separator }}</span>
            } {{ value[optionsTextObjectKey.key] }}</span
            >
          }
        }
      </ng-option>
    }
  </ng-select>
